import { Component, OnInit } from '@angular/core';
import { IPromocionHomeCardDetails } from '@common/interfaces/promocion-home-card-details.interface';

@Component({
  selector: 'app-promociones-home',
  templateUrl: './promociones-home.component.html',
  styleUrls: ['./promociones-home.component.scss'],
})
export class PromocionesHomeComponent implements OnInit {

  items: IPromocionHomeCardDetails[] = [
    // {
    //   title: "Multiplica tus Puntos",
    //   icon: "/assets/img/svg/RipleyPuntos GO.jpg",
    //   iconStyle: "margin: 2px 0 !important;",
    //   subtitle: `Gana hasta 5,000 Puntos Go, sin sorteos`,
    //   content: `Compra TODOS los días desde S/100 y te regalamos un bono de 100 Puntos
    //       Go diarios y si compras todos los días llévate 5,000 Puntos Go SIN
    //       SORTEOS.`,
    //   conditions: `Válido del 01 al 31 de julio 2026. Tope: 5,000 inscritos. No aplican
    //       compras en Ripley.`,
    //   link: "https://simple.ripley.com.pe/minisitios/registro-promociones-ripley-peru",
    //   linkDataCategory: "RipleyPuntosGo Promocion",
    //   linkTitle: "Inscribete aquí"
    // },
    {
      title: "Descuento por ser Gold o Silver",
      icon: "/assets/img/svg/i-despacho-gratis.svg",
      subtitle: "Despacho gratis",
      content: `Por ser cliente Gold y Silver tienes despacho gratis en Ripley.com.pe`,
      conditions: `*TyC en sección Categoría de clientes / Ver Condiciones de Beneficios`,
      link: "/clientes-prime",
      linkDataCategory: "Categoría Promocion",
      linkTitle: "Conoce más aquí"
    },
    {
      title: "Gift Card Ripley",
      icon: "/assets/img/svg/i-gift-card-rpg.svg",
      subtitle: "Gift Card de S/50",
      content: `Aprovecha y canjéala por 2,500 Puntos Go`,
      link: "canjes?category=giftcards&pag=afiliacion",
      linkDataCategory: "Gift Card Promocion",
      linkTitle: "Más Info"
    },
  ];
  constructor() { }

  ngOnInit() {}

}
